<template>
  <div>
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
      <!-- <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i class="fas fa-download fa-sm text-white-50"></i> Generate Report</a> -->
    </div>

    <!-- Content Row -->
    <div class="row">

      <div class="col-xl-3 col-md-6 mb-4" v-for="(data,index) in arr_report" :key="'report_'+index">
        <div class="card shadow h-100 py-2" :class="data.border_left_class" @click="select_report(index)" style="cursor: pointer;">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{ data.title }}</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.value }}</div>
              </div>
              <div class="col-auto" v-html="data.icon">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Content Row -->

    <div class="row">

      <!-- Pie Chart -->
      <div class="col-xl-4 col-lg-5">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">Total User</h6>

          </div>
          <!-- Card Body -->
          <div class="card-body">
            <div class="chart-pie pt-4 pb-2">
              <canvas id="chart_user"></canvas>
            </div>
            <div class="mt-4 text-center small">
              <span class="mr-2">
                <i class="fas fa-circle text-primary"></i> Majikan
              </span>
              <span class="mr-2">
                <i class="fas fa-circle text-success"></i> Helper
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
export default {
  components:{
    'custom-table': custom_table,
  },
  data(){
    return{
      arr_report: [
        {
          title: 'Total Majikan Kontrak',
          icon: '<i class="fas fa-user-tie fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-primary',
          api_type: 'majikan_kontrak',
          value: '',
        },
        {
          title: 'Total Majikan Belum Kontrak',
          icon: '<i class="fas fa-user-tie fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-primary',
          api_type: 'majikan_belum_kontrak',
          value: '',
        },
        {
          title: 'Total Pekerja Kontrak',
          icon: '<i class="fas fa-user-friends fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-success',
          api_type: 'helper_kontrak',
          value: '',
        },
        {
          title: 'Total Pekerja Belum Kontrak',
          icon: '<i class="fas fa-user-friends fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-success',
          api_type: 'helper_belum_kontrak',
          value: '',
        },
        {
          title: 'Data Pekerja Tidak Lengkap',
          icon: '<i class="fas fa-user-friends fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-success',
          api_type: 'data_helper_tidak_lengkap',
          value: '',
        },
        {
          title: 'Total Pekerja Terverifikasi',
          icon: '<i class="fas fa-user-friends fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-warning',
          api_type: 'helper_terverifikasi',
          value: '',
        },
        {
          title: 'Total Kontrak Kerja Berjalan',
          icon: '<i class="fas fa-file-alt fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-warning',
          api_type: 'kontrak_berjalan',
          value: '',
        },
        {
          title: 'Total Kontrak Kerja Selesai',
          icon: '<i class="fas fa-file-alt fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-warning',
          api_type: 'kontrak_selesai',
          value: '',
        },
        {
          title: 'Total Rating & Review',
          icon: '<i class="fas fa-star fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-warning',
          api_type: 'kontrak_selesai',
          value: '',
        },
        {
          title: 'Total Belum Rating & Review',
          icon: '<i class="fas fa-star fa-2x text-gray-300"></i>',
          border_left_class: 'border-left-warning',
          api_type: 'kontrak_selesai',
          value: '',
        },
      ],
      total: {
        majikan: 0,
        helper: 0,
      }
    }
  },
  mounted(){
    for(let x in this.arr_report)
      this.get_data(x)
    this.get_total_data()
  },
  methods:{
    init_chart(){
      var ctx = document.getElementById('chart_user').getContext('2d');
      var myPieChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ["Majikan", "Helper"],
          datasets: [{
            data: [
              this.total.majikan,
              this.total.helper,
            ],
            backgroundColor: ['#4e73df', '#1cc88a'],
            hoverBackgroundColor: ['#2e59d9', '#17a673'],
            hoverBorderColor: "rgba(234, 236, 244, 1)",
          }],
        },
        options: {
          maintainAspectRatio: false,
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            caretPadding: 10,
          },
          legend: {
            display: false
          },
          cutoutPercentage: 80,
        },
      });
    },
    select_report(index){
      location.href = "/report/detail?type="+this.arr_report[index].api_type
    },
    async get_data(index){
      try{
        var response = await axios.get(base_url+'/report?api_type=web-admin&type='+this.arr_report[index].api_type)

        var response_data = response.data
        if(response_data.status == "success"){
          var data = this.arr_report[index]
          data.value = response_data.total_data
          this.$set(this.arr_report,index,data)
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_total_data(){
      try{
        var response = await axios.get(base_url+'/report/total-user')

        var response_data = response.data
        if(response_data.status == "success"){
          this.total.majikan = response_data.data.total_majikan
          this.total.helper = response_data.data.total_helper

          this.init_chart()
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
